webpackJsonpCfHeader([1,4],{

/***/ 76:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function __export(m) {
	    for (var p in m) {
	        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(97));

/***/ },

/***/ 97:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(16);
	var styles = __webpack_require__(124);
	exports.Approval = function (_ref) {
	  var message = _ref.message;
	
	  return _jsx("div", {
	    className: styles['container']
	  }, void 0, _jsx("div", {
	    className: styles['icon']
	  }), _jsx("div", {
	    className: styles['content']
	  }, void 0, message));
	};

/***/ },

/***/ 124:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2Fmd4ZDqJu7rPlxO","icon":"_31AJtVgg0IQYd_pg"};

/***/ },

/***/ 146:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var HonestWorkNew_1 = __webpack_require__(219);
	var React = __webpack_require__(16);
	var constants_1 = __webpack_require__(220);
	
	var _ref2 = _jsx(HonestWorkNew_1.HonestWorkNew, {});
	
	exports.HonestWorkWrapper = function (_ref) {
	    var qualityLevelInfo = _ref.qualityLevelInfo;
	
	    console.log(1, { qualityLevelInfo: qualityLevelInfo });
	    if (!qualityLevelInfo || qualityLevelInfo && qualityLevelInfo.levelOrder < constants_1.MAX_LEVEL_ORDER) {
	        return null;
	    }
	    console.log(2, { qualityLevelInfo: qualityLevelInfo });
	    return _ref2;
	};
	exports.default = exports.HonestWorkWrapper;

/***/ },

/***/ 147:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var IconSuccess16_1 = __webpack_require__(222);
	var utils_1 = __webpack_require__(224);
	var React = __webpack_require__(16);
	var styles = __webpack_require__(421);
	
	var _ref = _jsx(IconSuccess16_1.IconSuccess16, {});
	
	var _ref2 = _jsx("span", {}, void 0, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u044B");
	
	var _ref3 = _jsx(IconSuccess16_1.IconSuccess16, {});
	
	var _ref4 = _jsx("span", {}, void 0, "\u0412\u0435\u0436\u043B\u0438\u0432\u043E \u043E\u0431\u0449\u0430\u0435\u0442\u0441\u044F \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438");
	
	var _ref5 = _jsx(IconSuccess16_1.IconSuccess16, {});
	
	var _ref6 = _jsx("span", {}, void 0, "\u0412\u0441\u0435\u0433\u0434\u0430 \u043E\u0442\u0432\u0435\u0447\u0430\u0435\u0442 \u043D\u0430 \u0437\u0432\u043E\u043D\u043A\u0438 \u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F");
	
	var _ref7 = _jsx(IconSuccess16_1.IconSuccess16, {});
	
	var _ref8 = _jsx("span", {}, void 0, "\u0421\u043E\u0431\u043B\u044E\u0434\u0430\u0435\u0442 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0426\u0438\u0430\u043D");
	
	exports.WorkHonestlyTooltip = function () {
	  return _jsx("div", {
	    className: styles["container"],
	    onClick: utils_1.stopPropagation
	  }, void 0, _jsx("ul", {
	    className: styles["tooltip"]
	  }, void 0, _jsx("li", {
	    className: styles["tooltip_item"]
	  }, void 0, _ref, _ref2), _jsx("li", {
	    className: styles["tooltip_item"]
	  }, void 0, _ref3, _ref4), _jsx("li", {
	    className: styles["tooltip_item"]
	  }, void 0, _ref5, _ref6), _jsx("li", {
	    className: styles["tooltip_item"]
	  }, void 0, _ref7, _ref8)));
	};

/***/ },

/***/ 219:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var WorkHonestlyTooltip_1 = __webpack_require__(147);
	var React = __webpack_require__(16);
	var styles = __webpack_require__(420);
	
	var _ref = _jsx(WorkHonestlyTooltip_1.WorkHonestlyTooltip, {});
	
	exports.HonestWorkNew = function () {
	  return _jsx("div", {
	    className: styles["wrapper"]
	  }, void 0, _jsx("div", {
	    className: styles["star"]
	  }), _jsx("span", {
	    className: styles["text"]
	  }, void 0, "\u0421\u0443\u043F\u0435\u0440\u0430\u0433\u0435\u043D\u0442"), _jsx("div", {
	    className: styles["tooltip"]
	  }, void 0, _ref));
	};

/***/ },

/***/ 220:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MAX_LEVEL_ORDER = 4;

/***/ },

/***/ 221:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(16);
	
	var _ref = _jsx("svg", {
	  "aria-hidden": "true",
	  width: "16",
	  height: "16",
	  viewBox: "0 0 16 16",
	  fill: "none",
	  xmlns: "http://www.w3.org/2000/svg"
	}, void 0, _jsx("path", {
	  "fill-rule": "evenodd",
	  "clip-rule": "evenodd",
	  d: "M14.207 5.207 6.5 12.914 1.793 8.207l1.414-1.414L6.5 10.086l6.293-6.293 1.414 1.414Z",
	  fill: "#34ac0a"
	}));
	
	exports.IconSuccess16 = function () {
	  return _ref;
	};

/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function __export(m) {
	    for (var p in m) {
	        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(221));

/***/ },

/***/ 223:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ETooltipContent = {
	    Second: 'Размещает достоверные и качественные объявления',
	    Third: 'Долго работает с Циан и размещает\nдостоверные и качественные объявления',
	    Fourth: 'Один из лучших специалистов Циан. Размещает только достоверные объявления' + ' и предоставляет качественные услуги.',
	    Nothing: 'К сожалению информация отсутствует'
	};

/***/ },

/***/ 224:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(223);
	exports.getTooltipContent = function (n) {
	    switch (n) {
	        case 2:
	            return constants_1.ETooltipContent.Second;
	        case 3:
	            return constants_1.ETooltipContent.Third;
	        case 4:
	            return constants_1.ETooltipContent.Fourth;
	        default:
	            return constants_1.ETooltipContent.Nothing;
	    }
	};
	exports.stopPropagation = function (e) {
	    return e.stopPropagation();
	};

/***/ },

/***/ 420:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tooltip":"koBLqzsZPvYei6fd","wrapper":"_3rWK-Znp0dVYrw0s","star":"cXtvdHLai1zdZl6Z","text":"QRoMGunm_oNh_rDD"};

/***/ },

/***/ 421:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2EU3hArz_9wnQnH9","tooltip":"_1Ia6Xo50NHhVbcbP","tooltip_item":"_3Lke-44h5gekvlMb"};

/***/ }

});


// WEBPACK FOOTER //
// header-776a8de4976c5ff95a96.js